export const DOMAIN_TYPE = {
    PROJECT: 'PROJECT',                  //项目
    ENTERPRISE: 'ENTERPRISE',            //企业
};
